module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABUAAAABQBAMAAAAqxsI0AAAAIVBMVEXp6ekzMzM2Njavr6+hoaGmpqZHR0ezs7Otra22trapqak7AuM2AAABEElEQVR42u3ZMW7CQBQE0F/YDd26SI9SBLqIIr2PwBEsqnQ5Akeg4gCcNDbIpEs9SO+dYTR/tVMAAAAAAAAAAAAAAAAAAAAAAMAr6y4FucZ9QayuDSqUXGNrHwWhutba8FOQaWyDCiVWN6dzzuhnQaLjfN+71t4LAvX3865CCXW8R1OFkqlfktldlpyeC9LclgId90tQdwVhNtulQNugQol0mGP5WJL6rVcocaa2W5ekW3sryDIN53VJ2mwFlDTX09+S9PVdEMeSRDJLEtEsSSTrH8n0DUqm2+O2W5KIdF+SSoUS6rDG0pJEoul52C1JBJqed92SRKDrqVaWJAAAAAAAAAAAAAAAAAAAAACA//wCBSshawMwkR4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/mapBottom2.png
// module id = +Yfp
// module chunks = 104